import { render, staticRenderFns } from "./labor-agreements.vue?vue&type=template&id=d67d6e50&"
import script from "./labor-agreements.vue?vue&type=script&lang=js&"
export * from "./labor-agreements.vue?vue&type=script&lang=js&"
import style0 from "./labor-agreements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "labor-agreements.vue"
export default component.exports